import { Role } from '../types/auth.types';

export enum Permission {
  VIEW_PRODUCTS = 'view_products',
  MANAGE_CART = 'manage_cart',
  PLACE_ORDERS = 'place_orders',
  MANAGE_ORDERS = 'manage_orders',
  MANAGE_PRODUCTS = 'manage_products',
  ADMIN_ACCESS = 'admin_access',
}

export const ROLE_PERMISSIONS: Record<Role, Permission[]> = {
  [Role.GUEST]: [Permission.VIEW_PRODUCTS],
  [Role.CUSTOMER]: [
    Permission.VIEW_PRODUCTS,
    Permission.MANAGE_CART,
    Permission.PLACE_ORDERS,
  ],
  [Role.VENDOR]: [
    Permission.VIEW_PRODUCTS,
    Permission.MANAGE_PRODUCTS,
    Permission.MANAGE_ORDERS,
  ],
  [Role.ADMIN]: Object.values(Permission),
};

export const hasPermission = (role: Role, permission: Permission): boolean => {
  return ROLE_PERMISSIONS[role]?.includes(permission) ?? false;
};
